import { HeaderPage } from "../../../components/header-page/HeaderPage";

export const PromotionHeader = () => {
  return <HeaderPage title="Promociones" />;
};
